export const daysInStockColors = [
  '#00C4A3',
  '#5DB000',
  '#8FD400',
  '#CCDD00',
  '#FFE600',
  '#FFB800',
  '#FF8A00',
  '#FF5C00',
  '#B91C1C',
  '#2c3e50'
]

export const percentOfPercaysoColors = [...daysInStockColors]

export const marketDemandColors = [
  '#E5E7EB',
  '#1E40AF',
  '#DC2626',
  '#EA580C',
  '#F59E0B',
  '#84CC16',
  '#22C55E',
  '#059669'
]

export const dealerTypeColors = ['#E5E7EB', '#2563EB', '#F59E0B']

export const nearlyNewColors = ['#E5E7EB', '#7DD3FC', '#1E40AF']

export const modelColors = [
  '#87CEEB',
  '#4682B4',
  '#FF8C69',
  '#98FB98',
  '#DDA0DD'
]

export const mileageColors = [
  '#E5E7EB',
  '#1E3A8A',
  '#7DD3FC',
  '#06B6D4',
  '#10B981',
  '#84CC16',
  '#EAB308',
  '#F59E0B',
  '#EF4444',
  '#DC2626',
  '#7C2D12',
  '#92400E'
]
